import React, { useEffect, useState } from 'react'

import { publishEvent } from '@zet/analytics'
import { Stack } from '@zet/design-system'
import { i18n } from '@zet/localization'
import { ITeamEarningsFiltersDTO } from '@zet/my-teams/src/api/teamEarnings/types'
import EarningsHeader from '@zet/my-teams/src/components/earningsHeader'
import TotalEarningsSection from '@zet/my-teams/src/components/totalEarningsSection'

import {
  useMyTeamsEarnings,
  useMyTeamsEarningsFilters,
  useMyTeamsEarningsTotal,
} from '../../api/earnings/hooks'
import { myTeamEarningsFaqs } from '../../utils/Constants'
import TeamEarningsFilters from './earningsFilters/teamEarningsFilter'
import TeamEarningsList from './earningsList'
import useMyTeamsEarningsStore from './store/myTeamsEarnings'

const TeamEarningsPage = () => {
  const [filters, setFilters] = useState<ITeamEarningsFiltersDTO>({})
  const { data: totalEarnings, isFetching: isTotalEarningsFetching } =
    useMyTeamsEarningsTotal()
  const {
    data: _earningsData,
    isFetchingNextPage,
    fetchNextPage,
    refetch,
    isFetching,
  } = useMyTeamsEarnings(filters)
  const { data: filterData } = useMyTeamsEarningsFilters()
  const setMyTeamsEarningsFilters = useMyTeamsEarningsStore(
    (state) => state.setMyTeamsEarningsFilters
  )

  useEffect(() => {
    setMyTeamsEarningsFilters(filterData)
  }, [filterData])

  const earningsData = _earningsData?.pages?.flatMap(
    (page) => page.earningsList
  )
  useEffect(() => {
    publishEvent('screen_view', {
      screen_name: 'team_earnings',
    })
  }, [])

  return (
    <Stack className="bg-neutral-white100 flex-1 pt-2">
      <EarningsHeader
        title={i18n.t('myTeamsEarningsWidget.myEarnings')}
        faqs={myTeamEarningsFaqs}
      />
      {filters && (
        <TeamEarningsFilters filters={filters} setFilters={setFilters} />
      )}
      <TotalEarningsSection
        totalEarnings={totalEarnings?.total}
        fetching={isTotalEarningsFetching}
      />
      <TeamEarningsList
        data={earningsData || []}
        isFetching={isFetching}
        isFetchingNextPage={isFetchingNextPage}
        onEndReached={fetchNextPage}
        onRefresh={refetch}
      />
    </Stack>
  )
}

export default TeamEarningsPage
